import { ActivationBanner } from "../../components"
export const View = () => {
    return(
        <>
            <ActivationBanner 
            title="Please you need to activate your profile"
            subtitle="0ur guide will help you complete your Business profile and you’ll start receiving payments. Click this banner to complete your set-up."
            urlTarget="/onboarding"
            />
        </>
    )
}